import React from "react";

const SuccessMessage = ({ message }) => {
    return (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4" role="alert">
            {message}
        </div>
    );
};

export default SuccessMessage;